export const IntegrationTypeAWS = "aws/Initialize";
export const IntegrationTypeDuo = "duo/poll";
export const IntegrationTypeO365 = "o365/Initialize";
export const IntegrationTypeSentinelOne = "sentinelone/poll";
export const IntegrationTypeMimecast = "mimecast/poll";
export const IntegrationTypeWebroot = "webroot/poll";
export const IntegrationTypeUmbrella = "umbrella/poll";

export const INTEGRATION_STATUS = {
  INIT: "initializing",
  OK: "ok",
  ERROR: "error",
  DELETED: "deleted",
};

export const cloudModuleMetadata = [
  {
    title: "Amazon Web Services",
    subtitle: "Kinesis",
    imageWidth: 60,
    setupGuideLink: "https://blumira.help/aws",
    description: "",
    integrationType: IntegrationTypeAWS,
  },
  {
    title: "Duo Security",
    subtitle: "Authentication and endpoint",
    imageWidth: 70,
    setupGuideLink: "https://blumira.help/duo",
    description:
      "This cloud connector fetches events from the Duo Security Admin API. There are prerequisites that need to be completed in the Duo Admin Panel before continuing. Please open our setup guide in another browser window, then click Next below to get started.",
    integrationType: IntegrationTypeDuo,
  },
  {
    title: "Microsoft 365",
    subtitle: "Security event logs and alerts",
    setupGuideLink: "https://blumira.help/m365",
    description:
      "This cloud connector ingests audit logs from Microsoft 365. There are prerequisites that need to be completed in the Microsoft Admin Center before continuing. Please open our setup guide in another browser window, then click Next below to get started.",
    integrationType: IntegrationTypeO365,
  },
  {
    title: "SentinelOne",
    subtitle: "Alerts, Activities, and Threats",
    setupGuideLink: "https://blumira.help/sentinelone",
    description:
      "This cloud connector ingests Alerts and Activities logs from SentinelOne. There are prerequisites that need to be completed in SentinelOne before continuing. Please open our setup guide in another browser window, then click Next below to get started.",
    integrationType: IntegrationTypeSentinelOne,
  },
  {
    title: "Mimecast",
    subtitle: "Audit, Release, Rejection, and SIEM",
    setupGuideLink: "https://blumira.help/mimecast",
    description:
      "This cloud connector ingests audit, release, rejection, and SIEM logs from Mimecast. There are prerequisites that need to be completed in the Mimecasst Administration Console before continuing. Please open our setup guide in another browser window, then click Next below to get started.",
    integrationType: IntegrationTypeMimecast,
    dropDownValues: {
      management_url: [
        {
          label: "AU - https://au-api.mimecast.com",
          value: "https://au-api.mimecast.com",
        },
        {
          label: "CA - https://ca-api.mimecast.com",
          value: "https://ca-api.mimecast.com",
        },
        {
          label: "DE - https://de-api.mimecast.com",
          value: "https://de-api.mimecast.com",
        },
        {
          label: "EU - https://eu-api.mimecast.com",
          value: "https://eu-api.mimecast.com",
        },
        {
          label: "Offshore - https://je-api.mimecast.com",
          value: "https://je-api.mimecast.com",
        },
        {
          label: "US - https://us-api.mimecast.com",
          value: "https://us-api.mimecast.com",
        },
        {
          label: "USB - https://usb-api.mimecast.com",
          value: "https://usb-api.mimecast.com",
        },
        {
          label: "USPCOM - https://uspcom-api.mimecast-pscom-us.com",
          value: "https://uspcom-api.mimecast-pscom-us.com",
        },
        {
          label: "ZA - https://za-api.mimecast.com",
          value: "https://za-api.mimecast.com",
        },
      ],
    },
  },
  {
    title: "Webroot",
    subtitle: "Threat and URL Blocking",
    setupGuideLink: "https://blumira.help/webroot",
    description:
      "This cloud connector monitors Threats and URL Blocking from Webroot. There are prerequisites that need to be completed in Webroot before continuing. Please open our setup guide in another browser window, then click Next below to get started.",
    integrationType: IntegrationTypeWebroot,
  },
  {
    title: "Umbrella",
    subtitle: "Activity event logs",
    imageWidth: 150,
    setupGuideLink: "https://blumira.help/umbrella",
    description: "",
    integrationType: IntegrationTypeUmbrella,
  },
];
